var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindow = function SvgWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.083 16.667C7.083 9.779 12.85 3.75 20 3.75s12.917 6.029 12.917 12.917v16.666A2.916 2.916 0 0 1 30 36.25H10a2.917 2.917 0 0 1-2.917-2.917zM21.25 33.75H30a.417.417 0 0 0 .417-.417V22.917H21.25zm-2.5-10.833V33.75H10a.417.417 0 0 1-.417-.417V22.917zm2.5-2.5h9.167v-3.75c0-5.131-4.016-9.694-9.167-10.34zm-2.5-14.09v14.09H9.583v-3.75c0-5.131 4.015-9.694 9.167-10.34",
    clipRule: "evenodd"
  })));
};
export default SvgWindow;